// ! Routing for reducers for redux

import { combineReducers } from 'redux';
import navigation from './reducers/navigation.reducer';
import configuration from './reducers/configuration.reducer';
import preferences from './reducers/preferences.reducer';
import sources from './reducers/sources.reducer';
import targets from './reducers/targets.reducer';
import entities from './reducers/entities.reducer';
import flows from './reducers/flows.reducer';
import jobs from './reducers/jobs.reducer';
import ui from './reducers/ui.reducer';
import schemas from './reducers/schema.reducer';
import connectors from './reducers/connectors.reducer';

const appReducer = combineReducers({
  navigation,
  configuration,
  preferences,
  targets,
  flows,
  sources,
  entities,
  jobs,
  ui,
  schemas,
  connectors,
});

export default (state, action) => appReducer(state, action);
